export const transformEquation = (originalEquation: string) => {
  const formattedEquation: string = originalEquation
    .replace(/−/g, '-') // TECH-24857 replace unexpected dash/hyphen/minus-sign character
    .replace(/\\\\/g, '\\')
    .replace(/"/g, '')
    .replace(/({matrix}.*? \\)( .*?{matrix})/g, '$1\\$2'); // This is another fix for NAG-262, because we need to revert back to replace(/\\\\/g, '\\') above to fix all other issues.

  return formattedEquation;
};
